import { Injectable } from "@angular/core";
import { environment } from "projects/shared/environments/environment";
import { OrderService } from "projects/shared/services/order.service";
import { BehaviorSubject, Observable } from "rxjs";
import { io, Socket } from "socket.io-client";

@Injectable({
  providedIn: 'root'
})
export class OrdersSocketService {

  private baseURL = `${environment.apiUrl.replace('v1/', '')}`
  private socket: Socket | null = null;
  public isConnected = new BehaviorSubject<boolean>(false);
  newOrder = new BehaviorSubject<any>({});

  constructor(
    private _orderService: OrderService
  ) {
    this.initSocket();
  }

  initSocket(namespace: string = 'orders'): void {
    this.socket = io(`${this.baseURL}${namespace}`, {
      transports: ['websocket'],
    });
    this.setupSocketListeners(namespace)
  }

    private setupSocketListeners(namespace: string): void {
    if (!this.socket) return;

     this.socket.off('connect');
    this.socket.off('connect_error');
    this.socket.off('disconnect');
    this.socket.off('newNotification');

    this.socket.on('connect', () => {
      this.isConnected.next(true);
      this.socket?.emit('joinAdminRoom');

    });

    this.socket.on('connect_error', (error) => {
      this.isConnected.next(false);
      console.error(`Socket connection error to ${namespace}: ${error.message}`);
    });

    this.socket.on('disconnect', (reason) => {
      this.isConnected.next(false);
    });
    this.onNewOrder();
  }
  onNewOrder() {
    this.socket?.on('newOrder', data => {
      this._orderService.getCountOrders();
      this.newOrder.next(data);
    })
  }

}
